<template>
  <!-- 查询车辆授权弹框 -->
  <div class="search-authorization">
    <van-popup v-model="showDialog" @close="closeDialog" :close-on-click-overlay="false">
      <div class="content">
        <div class="close-box" @click="showDialog = false">
          <img src="../../../assets/images/search/icon-close.png" alt="" srcset="">
        </div>
        <div class="content-title">系统检测到您初次查询该车牌号</div>
        <div class="vno-box">{{ vno }}</div>
        <!-- <div class="remind-title font24">{{ is_travel ? '授权提醒：上传行驶证照片，永久查车位置' : '输入车架号，永久查车位置' }}</div> -->
        <div class="upload-box" v-if="is_travel && !show_result">
          <!-- 如果用户没用认证过，跳示例 -->
          <div class="upload-box-title">上传行驶证正面：</div>
          <van-uploader v-if="!is_example" :multiple="false" :max-count="1"   :after-read="afterRead" accept='image/*' class="flex" style="justify-content: center;">
            <div class="identity-back">
              <div class="camera-box">
                <img src="../../../assets/images/search/camera-icon.png" alt="">
              </div>
              <div class="camera-title font24">点击拍摄/上传</div>
            </div>
          </van-uploader>
          <div class="identity-back" @click="goExample" v-else>
            <div class="camera-box">
              <img src="../../../assets/images/search/camera-icon.png" alt="">
            </div>
            <div class="camera-title font24">点击拍摄/上传</div>
          </div>
          <div class="absent font24" @click="showframe">行驶证不在身边？<span>点击输入车架号</span></div>
        </div>
        <div class="frame-box" v-if="!is_travel && !show_result">
          <div class="upload-box-title">输入车架号后6位：</div>
          <van-field
            class="frame-box-input font24"
            v-model="vin"
            placeholder="请输入车架号后6位"
            :error-message="error_vin_message"
            maxlength="6"
            @input="vinChange"
          />
          <!-- <input class="frame-box-input font24" v-model="vin" placeholder="请输入该车车架号"  type="text" /> -->
          <div class="upload-btn font24" @click="showTravel">上传行驶证</div>
        </div>
        <van-loading class="loading-box" style="text-" type="spinner" v-show="showLoading" >审核中，请稍候</van-loading>
        <div class="pass font28 adopt" v-if="is_examine && show_result  ">审核通过!</div>
        <div class="examine-fail" v-if="!is_examine && show_result && !unTested">
          <div class="pass font36">审核失败!</div>
          <div class="font24 examine-fail-title">{{ is_travel ? '请核实车牌号；上传行驶证正面清晰照片' : '请核实车架号填写正确' }}</div>
          <div class="absent font24"  @click="showframe"  v-if="is_travel"><span>输入车架号</span></div>
          <!-- <div v-if="is_travel" class="font24 examine-fail-title">单个车牌号每天只能上传2次，请确保行驶证图片清晰</div>
          <div v-if="is_travel" class="surplus font24">您还能上传{{ examine_count }}次</div> -->
        </div>
        <!-- 如果是车架没数据，显示这个框 -->
        <div v-if="unTested" class="font36 examine-fail-title pass">审核失败!</div>
        <div class="guarantee-box">
          <div class="guarantee-title font22">为保障信息安全，未经授权不得查车</div>
          <div class="btn" v-if="show_result && is_examine && is_travel" @click="searchBtn">立即查询</div>
          <div class="btn" v-if="!show_result && !cangoSon" @click="searchBtn">授权永久查车</div>
          <div class="btn" @click="noticeSon" v-if="show_result && cangoSon">确定</div>
          <div class="btn" @click="againUpload" v-if="show_result && !is_examine && examine_count > 0 && is_travel">重新上传</div>
          <div class="btn" @click="againInput" v-if="show_result && !is_travel && !is_examine  && !unTested" >重新输入</div>
          <div class="btn" @click="againUpload" v-if="show_result && !is_travel && unTested && !is_examine">上传行驶证</div>
          <div class="guarantee-title font22">——我们将对信息严格保密，请放心填写——</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
const vinVerification = /^[A-Za-z0-9]+$/
import { userVehicleLicense, userCheckVnoAuth } from '../../../api/userInfoApi'
import { getItem, setItem } from '../../../utils/index'
import { Toast } from 'vant'
import lrz from 'lrz'
export default {
  props: {
    // 车牌号
    vno: {
      type: String,
      default () {
        return '沪BT8530'
      }
    },
    // 车牌号颜色
    vco: {
      type: Number,
      default () {
        return 1
      }
    }
  },
  data() {
    return {
      showDialog: false,
      is_travel: true, // 是否是行驶证
      vin: '', // 车架号
      fileList: [], // 上传的图片
      is_examine: false, // 是否审核成功
      show_result: false, // 是否有结果
      examine_count: 0, // 剩余审核次数
      error_vin_message: '', // 错误的车架号提示
      unTested: null, // 无法效验的message提示
      showLoading: false, // 显示加载动画
      cangoSon: false, // 是否可以去子组件
      is_example: true, // 是否看过示例
    };
  },
  computed: {
    user_id () {
      return this.$store.state.userInfo.user_content.userId || null
    },
  },
  components: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    /**
     *
     *
     *
     * 显示输入车架
    */
    showframe () {
      this.showLoading = false
      this.is_travel = false
      this.show_result = false
      this.vin = ''
      this.error_vin_message = ''
      this.unTested = null
      this.cangoSon = false
    },

    /**
     *
     *
     *
     * 显示上传驾驶证图片
    */
    showTravel () {
      this.is_travel = true
      this.showLoading = false
      if (this.examine_count === 0) {
        // 如果次数为0，显示结果页
        this.show_result = true
        this.cangoSon = true
      }
      if (this.examine_count === 1) {
        // 次数为1，显示失败
        this.show_result = true
        this.cangoSon = false
      }
      window.addEventListener('online',  this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)
    },

    /**
     *
     *
     * @param file 获取到的文件对象
     * 文件上传的钩子
     */
    async afterRead(file) {
      // console.log(navigator.onLine)
      let params = null
      const fileresult = await lrz(file.file, {
        width: 800,
        height: 1000,
        quality: 1
      })
      params = fileresult.formData
      params.append('vno', this.vno)
      params.append('vco', this.vco)
      if (!navigator.onLine) {
        Toast('网络错误')
        return
      }
      await this.uploadCamera(params)
    },

    /**
     *
     *
     *
     * 显示授权弹框
    */
    showPopup (examine_count) {
      this.showDialog = true
      this.is_travel = examine_count > 0
      this.examine_count = examine_count
      this.is_examine = false
      this.show_result = false
      this.cangoSon = false
      this.showLoading = false
      this.error_vin_message = ''
      this.unTested = null
      this.fileList = []
      if (examine_count === 1) {
        this.show_result = true
      }
      // 判断本地有没有示例过的数据
      const user_vno = `${this.user_id}_${this.vno}` // 用来判断用户是不是看过示例
      let exampleData = JSON.parse(getItem('exampleData')) || null
      if (exampleData) {
        this.is_example = exampleData.indexOf(user_vno) >= 0 ? false : true
      } else {
        setItem('exampleData', JSON.stringify([]))
        this.is_example = true
      }
    },

    /**
     *
     *
     *
     * 上传驾驶证图片
    */
    async uploadCamera (params) {
      this.showLoading = true
      const response = await userVehicleLicense(params)
      this.showLoading = false
      if (response && response.isSuccess) {
        this.show_result = true
        const { isSuccess, remainderTime } = response.data
        this.is_examine = isSuccess
        this.examine_count = remainderTime
        if (isSuccess) {
          this.is_examine = true
          this.cangoSon = false
          this.show_result = true
        } else {
          this.is_examine = false
          this.examine_count = remainderTime
          if (remainderTime === 0 || this.is_examine) this.cangoSon = true
        }
        console.log(response)
      }
    },

    /**
     *
     *
     *
     * 监听网络断开
    */
    updateOnlineStatus (e) {
      const { type } = e
      if (type === 'offline') {
        this.showLoading = false
      }
    },

    /**
     *
     *
     *
     * 关闭弹框
    */
    closeDialog () {
      window.removeEventListener('online',  this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    },

    /**
     *
     *
     *
     * 车架号验证
    */
    async checkVnoAuth () {
      this.showLoading = true
      const { vno, vco, vin } = this
      const params = {
        vno,
        vco,
        vin
      }
      const response = await userCheckVnoAuth(params)
      this.showLoading = false
      if (response && response.isSuccess) {
        const { hasAuth, msg, code } = response.data
        this.show_result = true
        if (hasAuth) {
          this.show_result = false
          this.showDialog = false
          this.$emit('success')
        } else {
          this.is_examine = hasAuth
        }
        if (code === 2) {
          this.unTested = msg
          Toast('该车车架号无法效验，请上传行驶证照片')
        }
      }
    },

    /**
     *
     *
     *
     * 重新输入
    */
    againInput () {
      this.vin = ''
      this.show_result = false
      this.is_travel = false
    },

    /**
     *
     *
     *
     * 重新上传
    */
    againUpload () {
      this.fileList = []
      this.show_result = false
      this.is_travel = true
      this.unTested = null
    },

    /**
     *
     *
     *
     * 通知子组件成功
    */
    noticeSon () {
      this.showDialog = false
      if (this.is_examine) this.$emit('success')
    },

    /**
     *
     *
     *
     * 查询btn
    */
    searchBtn () {
      if (this.is_examine) {
        this.showDialog = false
        this.$emit('success')
      } else {
        if (!this.is_travel) {
          if (this.vin === '') {
            Toast('请输入车架号')
            return
          }
          if (this.error_vin_message !== '') {
            return
          }
          this.checkVnoAuth()
        } else {
          Toast('请上传行驶证照片')
        }
      }
    },

    /**
     *
     *
     *  @param value 输入的车架号
     * 验证输入的车架号是否正确
    */
    vinChange (value) {
      if (!vinVerification.test(value) || value.length < 6) {
        this.error_vin_message = '请输入正确的车架号'
      } else {
        this.error_vin_message = ''
      }
      if (value === '') this.error_vin_message = ''
    },

    /**
     *
     *
     *
     * 跳示例页面
    */
    goExample () {
      this.$router.push('/attestation-example')
    }
  }
};
</script>

<style scoped lang="scss">
.search-authorization>:first-child {
  background-color: rgba(0,0,0,.4)
}
.search-authorization>:nth-child(2){
  width: 80%;
  border-radius: 6px;
}
.search-authorization {
  .font24 {
    font-size: 24px;
  }
  .font22 {
    font-size: 22px;
  }
  .font36 {
    font-size: 36px;
  }
  .content {
    padding: 20px 40px;
    background-color: #ffffff;
    position: relative;
    .close-box {
      position: absolute;
      right: 20px;
      top: 20px;
      img {
        width: 30px;
      }
    }
    .loading-box {
      text-align: center;
      padding-top: 20px;
    }
    .content-title {
      font-size: 24px;
      color: #000000;
      text-align: center;
      padding: 40px 0 30px 0;
    }
    .vno-box {
      background-color: #F8F8F8;
      box-shadow: 0px 6px 15px 1px rgba(179, 179, 179, 0.35);
      border-radius: 35px;
      height: 70px;
      width: 320px;
      line-height: 70px;
      margin: 0 auto;
      text-align: center;
      font-size: 28px;
    }
    .upload-box-title {
      font-weight:500;
      color: rgba(1, 1, 1, .5);
      font-size: 28px;
      padding: 40px 0 20px 80px;
    }
    .remind-title {
      color: #5277FD;
      padding: 60px 30px 20px 30px;
      text-align: center;
    }
    .frame-box {
      .upload-box-title {
        padding-left: 0;
        text-align: left;
      }
    }
    .identity-back {
      display:table;
      margin:0 auto;
      width: 380px;
      height: 200px;
      background-image: url('../../../assets/images/search/identity-back.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      text-align: center;
      .camera-box {
        width: 70px;
        margin: 0 auto;
        padding-top: 52px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .camera-title {
        color: #999999;
        padding-top: 10px;
        font-weight: bold;
        font-size: 20px;
        span {
          color: #5572FD;
        }
      }

    }
    .absent {
      color:#999999;
      text-align: center;
      padding-top: 40px;
      span {
        color: #5F8AFE;
        text-decoration:underline;
      }
    }
    .guarantee-box {
      padding: 40px 0 20px 0;
      .guarantee-title {
        color: rgba(0,0,0,.1);
        text-align: center;
      }
      .btn {
        color: #ffffff;
        text-align: center;
        margin: 10px 20px;
        background:rgba(95,138,254,1);
        border-radius:40px;
        height: 80px;
        line-height: 80px
      }
    }
    .frame-box {
      margin: 10px 20px;
      .frame-box-input {
        background-color: #E5E5E5;
        color: #666666;
        // line-height: 70px;
        // height: 70px;
        width: 100%;
        border-radius: 4px;
        padding-left: 20px;
      }
      .frame-box-input>:nth-child(1)>:nth-child(1) {
        ::-webkit-input-placeholder { /* WebKit browsers */
          color: #cccccc;
        }
      }
      .upload-btn {
        color: #5F8AFE;
        text-align: center;
        text-decoration:underline;
        padding-top: 20px;
      }
    }
    .pass {
      text-align: center;
      font-weight: bold;
      color: #F72B2B;
      padding: 30px 0 36px 0;
    }
    .adopt {
      color: #5F8AFE !important;
      padding-top: 100px;
    }
    .un-tested {
      padding: 30px 20px;
      color:#999999;
      text-align: center;
    }
    .examine-fail {
      padding: 0 20px;
      padding-top: 60px;
      .examine-fail-title {
        color:#999999;
        text-align: center;
      }
      .surplus {
        padding-top: 20px;
        text-align: center;
        color: #FF1728;
      }
    }
  }
}

</style>